import React, { useEffect, useCallback } from 'react'
import { connect } from 'react-redux'
import { actionCreators } from '@/store/settings'
import { Main, MainTop, MainTopTitle, MainBody } from '@/components/Layout'
import Resx from '@/components/Resx'
import { SettingsForm } from './form'

const SettingsPage = ({ settings, get, save }) => {
  useEffect(() => { get() }, [get])
  const handleSave = useCallback((dto) => { save(dto) }, [save])
  return (
    <Main>
      <MainTop>
        <MainTopTitle><Resx name='Common.SettingsPageTitle' /></MainTopTitle>
      </MainTop>
      <MainBody>
        <SettingsForm
          key={settings.componentKey}
          settings={settings.settings}
          fetching={settings.fetching}
          updating={settings.updating}
          onSave={handleSave} />
      </MainBody>
    </Main>
  )
}

const mapStateToProps = (state, ownProps) => ({
  settings: state.settings,
  ...ownProps
})

const mapDispatchToProps = {
  get: actionCreators.get,
  save: actionCreators.save
}

export default connect(mapStateToProps, mapDispatchToProps)(SettingsPage)



// WEBPACK FOOTER //
// ./src/internal-app/pages/administration/settings/index.js